import { useImageParse, type UseImageParseProps } from './_useImageParse';
import { useImageSizes, type UseImageSizesProps } from './_useImageSizes';

/**
 * UseImage Types
 */

type UseImage = UseImageParseProps & UseImageSizesProps;

/**
 * UseImage Hook
 */

export const useImage = ({ src, sizes }: UseImage) => {
  const imageParse = useImageParse({ src });

  const imageSizes = useImageSizes({ sizes });

  return {
    ...imageParse,
    ...imageSizes,
  };
};

export default useImage;
